import { datumKort } from "@/lib/datum";
const MND = ["jan", "feb", "mrt", "apr", "mei", "jun", "jul", "aug", "sep", "okt", "nov", "dec"];

function mondayOf(week) {
  const [y, w] = week.split("-W").map((x) => parseInt(x, 10));
  const jan4 = new Date(Date.UTC(y, 0, 4));
  const m = new Date(jan4);
  m.setUTCDate(jan4.getUTCDate() - ((jan4.getUTCDay() || 7) - 1) + (w - 1) * 7);
  return m;
}

export function weekNr(week) { return week ? parseInt(week.split("-W")[1], 10) : ""; }

export function weekLabel(week) {
  const m = mondayOf(week);
  const z = new Date(m); z.setUTCDate(m.getUTCDate() + 6);
  return `Week ${weekNr(week)} · ${m.getUTCDate()} ${MND[m.getUTCMonth()]} – ${z.getUTCDate()} ${MND[z.getUTCMonth()]}`;
}

export function kortDatum(iso) {
  return datumKort(iso);   // v18 C3
}

export const KPIS = [["O", "omzet"], ["B", "bijverkoop"], ["P", "pk"], ["WOW", "wow"]];

export function kpiTone(v) {
  if (v === "behaald" || v === "ja") return "bg-emerald-100 text-emerald-800 border-emerald-200";
  if (v === "niet" || v === "nee") return "bg-rose-100 text-rose-800 border-rose-200";
  return "bg-zinc-100 text-zinc-400 border-zinc-200";
}

export function randKleur(r) {
  if (r.rood) return "border-l-rose-500";
  if (r.status === "aandacht") return "border-l-amber-500";
  if (r.status === "nog-te-bellen") return "border-l-blue-500";
  if (r.status === "geen-call") return "border-l-zinc-300";
  return "border-l-emerald-500";
}

// v10-A1: de server levert callInfo; het scherm plakt alleen de woorden aan elkaar.
export const callTekst = (c) => (c?.callInfo ? `Call ${c.callInfo.callLabel} · over week ${c.callInfo.overWeekNr}` : "");

const REDEN = {
  rood: "Rood", "rood-zonder-afspraak": "Rood zonder afspraak", "cijfers-ontbreken": "Cijfers ontbreken",
  "cijfers-onvolledig": "Cijfers onvolledig", "geen-call-deze-week": "Geen call deze week", "nog-te-bellen": "Nog te bellen",
};
export const redenLabel = (r) => (r.code === "te-laat" ? `${r.aantal} ${r.aantal === 1 ? "afspraak" : "afspraken"} te laat` : REDEN[r.code] || r.code);
export const redenTone = (code) => (code.startsWith("rood") ? "bg-rose-600 text-white border-rose-600"
  : code === "nog-te-bellen" ? "bg-blue-50 text-blue-700 border-blue-200" : "bg-amber-100 text-amber-900 border-amber-300");

export const VB_PILL = {
  volledig: "bg-emerald-100 text-emerald-800 border-emerald-200",
  onvolledig: "bg-amber-100 text-amber-800 border-amber-200",
  niets: "bg-rose-100 text-rose-800 border-rose-200",
  open: "bg-zinc-100 text-zinc-600 border-zinc-200",
  "geen-account": "bg-zinc-100 text-zinc-500 border-zinc-200",
};

export const VB_LABEL = { "geen-account": "Geen account" };

export const cap = (s) => (s ? s.charAt(0).toUpperCase() + s.slice(1) : s);
